


































import Vue from "vue";
import { computed } from "@vue/composition-api";

type Shape = {
  d?: string;
  circle?: [number, number, number];
  /** x, y, width, height, rx */
  rect?: [number, number, number, number, number];
};

/** path data from lucide-react 1.28 (ISC), as gen-ai-ui renders them */
const ICONS: Record<string, Shape[]> = {
  "chart-column": [
    { d: "M3 3v16a2 2 0 0 0 2 2h16" },
    { d: "M18 17V9" },
    { d: "M13 17V5" },
    { d: "M8 17v-3" },
  ],
  "chart-pie": [
    {
      d: "M21 12c.552 0 1.005-.449.95-.998a10 10 0 0 0-8.953-8.951c-.55-.055-.998.398-.998.95v8a1 1 0 0 0 1 1z",
    },
    { d: "M21.21 15.89A10 10 0 1 1 8 2.83" },
  ],
  activity: [
    {
      d: "M22 12h-2.48a2 2 0 0 0-1.93 1.46l-2.35 8.36a.25.25 0 0 1-.48 0L9.24 2.18a.25.25 0 0 0-.48 0l-2.35 8.36A2 2 0 0 1 4.49 12H2",
    },
  ],
  users: [
    { d: "M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2" },
    { d: "M16 3.128a4 4 0 0 1 0 7.744" },
    { d: "M22 21v-2a4 4 0 0 0-3-3.87" },
    { circle: [9, 7, 4] },
  ],
  "arrow-up-right": [{ d: "M7 7h10v10" }, { d: "M7 17 17 7" }],
  sparkles: [
    {
      d: "M11.017 2.814a1 1 0 0 1 1.966 0l1.051 5.558a2 2 0 0 0 1.594 1.594l5.558 1.051a1 1 0 0 1 0 1.966l-5.558 1.051a2 2 0 0 0-1.594 1.594l-1.051 5.558a1 1 0 0 1-1.966 0l-1.051-5.558a2 2 0 0 0-1.594-1.594l-5.558-1.051a1 1 0 0 1 0-1.966l5.558-1.051a2 2 0 0 0 1.594-1.594z",
    },
    { d: "M20 2v4" },
    { d: "M22 4h-4" },
    { circle: [4, 20, 2] },
  ],
  pencil: [
    {
      d: "M21.174 6.812a1 1 0 0 0-3.986-3.987L3.842 16.174a2 2 0 0 0-.5.83l-1.321 4.352a.5.5 0 0 0 .623.622l4.353-1.32a2 2 0 0 0 .83-.497z",
    },
    { d: "m15 5 4 4" },
  ],
  "arrow-left-right": [
    { d: "M8 3 4 7l4 4" },
    { d: "M4 7h16" },
    { d: "m16 21 4-4-4-4" },
    { d: "M20 17H4" },
  ],
  "arrow-left": [{ d: "m12 19-7-7 7-7" }, { d: "M19 12H5" }],
  "file-spreadsheet": [
    {
      d: "M6 22a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h8a2.4 2.4 0 0 1 1.704.706l3.588 3.588A2.4 2.4 0 0 1 20 8v12a2 2 0 0 1-2 2z",
    },
    { d: "M14 2v5a1 1 0 0 0 1 1h5" },
    { d: "M8 13h2" },
    { d: "M14 13h2" },
    { d: "M8 17h2" },
    { d: "M14 17h2" },
  ],
  menu: [{ d: "M4 5h16" }, { d: "M4 12h16" }, { d: "M4 19h16" }],
  "ellipsis-vertical": [
    { circle: [12, 12, 1] },
    { circle: [12, 5, 1] },
    { circle: [12, 19, 1] },
  ],
  binoculars: [
    { d: "M10 10h4" },
    { d: "M19 7V4a1 1 0 0 0-1-1h-2a1 1 0 0 0-1 1v3" },
    {
      d: "M20 21a2 2 0 0 0 2-2v-3.851c0-1.39-2-2.962-2-4.829V8a1 1 0 0 0-1-1h-4a1 1 0 0 0-1 1v11a2 2 0 0 0 2 2z",
    },
    { d: "M 22 16 L 2 16" },
    {
      d: "M4 21a2 2 0 0 1-2-2v-3.851c0-1.39 2-2.962 2-4.829V8a1 1 0 0 1 1-1h4a1 1 0 0 1 1 1v11a2 2 0 0 1-2 2z",
    },
    { d: "M9 7V4a1 1 0 0 0-1-1H6a1 1 0 0 0-1 1v3" },
  ],
  wrench: [
    {
      d: "M14.7 6.3a1 1 0 0 0 0 1.4l1.6 1.6a1 1 0 0 0 1.4 0l3.106-3.105c.32-.322.863-.22.983.218a6 6 0 0 1-8.259 7.057l-7.91 7.91a1 1 0 0 1-2.999-3l7.91-7.91a6 6 0 0 1 7.057-8.259c.438.12.54.662.219.984z",
    },
  ],
  "clipboard-check": [
    { rect: [8, 2, 8, 4, 1] },
    { d: "M16 4h2a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h2" },
    { d: "m9 14 2 2 4-4" },
  ],
  user: [{ d: "M19 21v-2a4 4 0 0 0-4-4H9a4 4 0 0 0-4 4v2" }, { circle: [12, 7, 4] }],
  bot: [
    { d: "M12 8V4H8" },
    { rect: [4, 8, 16, 12, 2] },
    { d: "M2 14h2" },
    { d: "M20 14h2" },
    { d: "M15 13v2" },
    { d: "M9 13v2" },
  ],
  "file-text": [
    {
      d: "M6 22a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h8a2.4 2.4 0 0 1 1.704.706l3.588 3.588A2.4 2.4 0 0 1 20 8v12a2 2 0 0 1-2 2z",
    },
    { d: "M14 2v5a1 1 0 0 0 1 1h5" },
    { d: "M10 9H8" },
    { d: "M16 13H8" },
    { d: "M16 17H8" },
  ],
  "chevron-right": [{ d: "m9 18 6-6-6-6" }],
  "chevron-down": [{ d: "m6 9 6 6 6-6" }],
  "chevron-up": [{ d: "m18 15-6-6-6 6" }],
  lock: [{ rect: [3, 11, 18, 11, 2] }, { d: "M7 11V7a5 5 0 0 1 10 0v4" }],
  x: [{ d: "M18 6 6 18" }, { d: "m6 6 12 12" }],
  "chart-no-axes-column": [{ d: "M5 21v-6" }, { d: "M12 21V3" }, { d: "M19 21V9" }],
  eye: [
    {
      d: "M2.062 12.348a1 1 0 0 1 0-.696 10.75 10.75 0 0 1 19.876 0 1 1 0 0 1 0 .696 10.75 10.75 0 0 1-19.876 0",
    },
    { circle: [12, 12, 3] },
  ],
  info: [{ circle: [12, 12, 10] }, { d: "M12 16v-4" }, { d: "M12 8h.01" }],
};

export default Vue.extend({
  props: {
    name: { type: String, required: true },
    stroke: { type: [Number, String], default: 2 },
  },
  setup(props) {
    const shapes = computed(() => ICONS[props.name as string] || []);
    return { shapes };
  },
});
